import { render } from "./AboutPage.vue?vue&type=template&id=9652f4e6&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=9652f4e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9652f4e6"]])

export default __exports__